var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPlaces = function SvgPlaces(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.9,
    viewBox: "0 0 18 17",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a3.941 3.941 0 0 0-3.938 3.938c0 1.78 2.563 4.968 3.532 6.156a.547.547 0 0 0 .781 0c.969-1.188 3.563-4.375 3.563-6.156C12.938 1.78 11.155 0 9 0Zm0 5.25c-.75 0-1.313-.563-1.313-1.313A1.3 1.3 0 0 1 9 2.625a1.32 1.32 0 0 1 1.313 1.313A1.3 1.3 0 0 1 9 5.25ZM.625 6.75A1.023 1.023 0 0 0 0 7.688V15.5c0 .375.344.625.656.469L5 14V6.719c-.281-.5-.531-.969-.688-1.438L.626 6.75ZM9 11.25c-.469 0-.875-.188-1.156-.531C7.219 10 6.562 9.188 6 8.313V14l6 2V8.312a25.723 25.723 0 0 1-1.875 2.407A1.437 1.437 0 0 1 9 11.25Zm8.313-6.188L13 7v9l4.344-1.719c.375-.156.656-.531.656-.937V5.53c0-.375-.375-.625-.688-.468Z"
  })));
};
export default SvgPlaces;